import {Helmet} from '@dr.pogodin/react-helmet';
import {Box, Center} from 'platform/foundation';

import i18n from '@dms/i18n';
import {customerRoutes, testIds} from '@dms/routes';
import {CustomerWidgetCard, EntityHeader, Page, Section} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

export function CreateCustomer() {
  const navigate = useNavigate();

  return (
    <>
      <Helmet title={i18n.t('page.customerCreate.title')} />
      <Page
        isFullHeight
        header={
          <EntityHeader
            variant="create"
            data-testid={testIds.customer.create('header')}
            title={i18n.t('page.customerCreate.title')}
            actions={[
              {
                type: 'button',
                variant: 'secondary',
                title: i18n.t('general.actions.discard'),
                onClick: () => navigate(customerRoutes.overview),
              },
            ]}
            flags={[{label: i18n.t('general.labels.draft'), colorScheme: 'neutral'}]}
            icon="social/person_add"
          />
        }
        data-testid={testIds.employee.createEmployee('createEmployee')}
      >
        <Section>
          <Center>
            <Box maxWidth={166} width="100%">
              <CustomerWidgetCard
                customTitle={i18n.t('entity.customer.labels.customerInformation')}
                secondStepComponentType="SERVICE_CASE"
                onCustomer={(customer) =>
                  navigate(composePath(customerRoutes.detail, {params: {id: customer.id}}))
                }
                data-testid={testIds.customer.create('widget')}
              />
            </Box>
          </Center>
        </Section>
      </Page>
    </>
  );
}
